import { QualifiedFeature } from "./shared";
import { gql } from "apollo-boost";

export const RuleValue = gql`
  fragment RuleValue on RuleValue {
    ruleValueId
    prob
    lift
    type
    citationsObj {
      id
      vancouver
      url
      title
      containerTitle
      DOI
    }
    citations
    exactCitation
  }
  ${QualifiedFeature}
`;

export const RuleStat = gql`
  fragment RuleStat on RuleStat {
    overloadSource {
      ...QualifiedFeature
    }
    overloadTarget {
      ...QualifiedFeature
    }
    overloadSourceType
    overloadTargetType
    prob
    lift
    type
    ruleValue {
      ...RuleValue
    }
    edgeStat {
      rate
      unit
    }
  }
  ${QualifiedFeature}
  ${RuleValue}
`;

export const PairGraph = gql`
  fragment PairGraph on Graph {
    nodes {
      id
      qfs {
        ...QualifiedFeature
      }
      probability
      percentRange {
        min
        max
      }
      isConnected
      type
      sourceQFIndex
    }
    edges {
      id
      sourceID
      targetID
      prob
      lift
      type
      ruleValues {
        ...RuleStat
      }
      usedInComputation
      ruleValueId
    }
  }
  ${QualifiedFeature}
  ${RuleStat}
`;

export const GraphQuery = {
  Graph: gql`
    query getGraph(
      $root: QualifiedFeatureInput
      $nodes: [GroupedFeature]
      $qfLight: Boolean = true
      $includeFeatureRange: Boolean = false
    ) {
      graph(root: $root, nodes: $nodes) {
        graph {
          ...PairGraph
        }
      }
    }
    ${PairGraph}
  `,
  GraphByIDS: gql`
    query getGraphByIDS(
      $root: ID
      $active: [ID]
      $background: [ID]
      $subtypes: [ID] = []
      $simplify: Boolean = true
      $qfLight: Boolean = true
      $includeFeatureRange: Boolean = false
    ) {
      graphByCohorts(
        root: $root
        background: $background
        active: $active
        subtypes: $subtypes
        simplify: $simplify
      ) {
        graph {
          ...PairGraph
        }
      }
    }
    ${PairGraph}
  `,
};
